import { UserData } from '@tm/types/common/app-api/auth'

export type CrispPushItem = string | number | boolean | Record<string, string> | undefined | CrispPushItem[]

export type CrispPush = (item: CrispPushItem) => void

export interface CrispWindow extends Window {
  $crisp?: CrispPushItem[]
}

const isCrispValue = (entry: [string, unknown]): entry is [string, string | number | boolean] =>
  ['string', 'number', 'boolean'].includes(typeof entry[1])

const crispPush: CrispPush = (item: CrispPushItem) => {
  const crispWin = window as unknown as CrispWindow
  crispWin.$crisp = crispWin.$crisp || []
  crispWin.$crisp.push(item)
}

export const updateCrisp = (userData: UserData, push: CrispPush = crispPush) => {
  try {
    const { email, name, crispHash, organization } = userData
    if (!crispHash) return

    const { name: organization_name, id: organization_id, appSubscriptionInfo } = userData.organization
    const plan_id = appSubscriptionInfo?.plan_id
    // The subscription object is only attached when the auth route asks for it; don't let a
    // missing one take the whole session:data set down with it.
    const plans = appSubscriptionInfo?.subscription?.data?.plans || []
    const plan = plans.length ? plans.map(plan => plan.planId).join(', ') : plan_id

    push(['set', 'user:email', [email, crispHash]])

    if (name) push(['set', 'user:nickname', name])

    const sessionData: [string, string | number | boolean | null | undefined][] = [
      ['organization', organization_name],
      ['organization_id', organization_id],
      ['plan', plan],
      ['admin2_url', `https://admin2.trustmary.com/organization/${organization_id}`],
      ['admin_plan_url', `https://admin.trustmary.com/settings/plan?limit=1000&editId=${plan_id}`],
      ['ARR', userData.organization.ARR],
      ['vainu_company_size', organization?.vainu_company_size],
      ['vainu_website_ranking', organization?.vainu_website_ranking],
      ['vainu_industries', organization?.vainu_industries?.join(', ')],
    ]

    // Crisp accepts only string, number or boolean values and throws on anything else, which
    // silently dropped every field for organizations without Vainu data (DEV-3276).
    push(['set', 'session:data', [sessionData.filter(isCrispValue)]])

    const website = organization?.website

    push(['set', 'user:company', [organization_name, website ? { url: website } : undefined]])
  } catch (error) {
    console.error('Crisp error updateCrisp', error)
  }
}

export const resetCrisp = (push: CrispPush = crispPush) => {
  try {
    push(['do', 'session:reset'])
  } catch (error) {
    console.log('Crisp error resetCrisp')
    console.log(error)
  }
}
